/**
 * 撮合成交模态框: 中标车辆的正常成交
 * props: visible             [boolean]     是否展示模态框
 *        orderId             [string]      订单id
 *        winningPrice    [string|number]    中标价
 *        onOk                [function]    撮合成交成功后的回调
 *        onCancel            [function]    取消撮合成交
 */
import React, { Component } from 'react';
import store, { dispatch } from '@@/store';
import ReactDOM from 'react-dom';
import { Modal, Form, Input, Radio } from 'antd';
import { CHECK_Money7, CHECK_name } from '@/shared/reqexp';
import InputNum from './components/InputNum';
import { connect, Provider } from '@souche-f2e/muji';
const mapStateToProps = (rootState) => ({
    _state: rootState.normalDeal,
});
class NormalDealTemp extends Component {
    constructor() {
        super(...arguments);
        this.handleOk = () => {
            // 点击确认
            dispatch.normalDeal.handleOk(this.props);
        };
        this.handleCancel = () => {
            // 点击取消
            dispatch.normalDeal.handleCancel(this.props);
        };
        this.handleInput = (type) => {
            // 清除红框提示
            const { winningPrice } = this.props.form.getFieldsValue();
            const _obj = {
                winningPrice: { value: winningPrice },
            };
            delete _obj[type];
            this.props.form.setFields(_obj);
            dispatch.normalDeal.SET_STATE({ notEqualToHandPrice: false });
        };
    }
    render() {
        const { sellerPriceYuanUnit, transferMode, showNormalDeal } = this.props._state;
        const { getFieldDecorator } = this.props.form;
        const { notEqualToHandPrice } = this.props._state;
        // const { showTransferWay = true } = optionsObj || {};
        return (<Modal title="正常成交" visible={showNormalDeal} okText="保存" onOk={this.handleOk} cancelText="取消" onCancel={this.handleCancel}>
        <Form style={{ marginTop: '20px' }} labelCol={{ span: 4 }} wrapperCol={{ span: 17 }} labelAlign="left">
          <Form.Item label="中标价">
            {getFieldDecorator('priorityOffer', {
            rules: [
                { required: true, message: '请输入中标价' },
                { pattern: CHECK_Money7, message: '请输入不超过七位数的整百数，可为0' },
            ],
            initialValue: Number(sellerPriceYuanUnit) || '',
        })(<InputNum onChange={() => this.handleInput('winningPrice')}/>)}
            {notEqualToHandPrice ? <span style={{ color: 'red' }}>修改价格不可高于{sellerPriceYuanUnit}元</span> : ''}
          </Form.Item>
          {transferMode && <Form.Item label="过户方式">
              {getFieldDecorator('transferType', {
            rules: [
                { required: true, message: '请选择过户方式' },
            ],
            initialValue: 3,
        })(<Radio.Group>
                  <Radio value={2}>卖方过户</Radio>
                  <Radio value={3}>买方过户</Radio>
                </Radio.Group>)}
            </Form.Item>}
          <Form.Item label="备注" wrapperCol={{ span: 20 }}>
            {getFieldDecorator('remark', {
            rules: [
                { validator: CHECK_name(200) },
            ],
        })(<Input.TextArea className="delTextAreaRightDown" rows={4} placeholder="请输入更改原因（选填，100字内）"/>)}
          </Form.Item>
        </Form>
      </Modal>);
    }
}
const NormalDeal = Form.create()(NormalDealTemp);
const NormalDealTmp = connect(mapStateToProps, null, null, { forwardRef: true })(NormalDeal);
export default NormalDealTmp;
let componentRef = '';
const createNormalDeal = () => {
    const div = document.createElement('div');
    div.className = 'souche-normal-deal';
    document.body.appendChild(div);
    // @ts-ignore
    const component = (
    // @ts-ignore
    <Provider store={store}>
      {React.createElement(NormalDealTmp, {
        // @ts-ignore
        ref: (ref) => {
            componentRef = ref;
        },
        _removeElement() {
            ReactDOM.unmountComponentAtNode(div);
            document.body.removeChild(div);
        },
    })}
    </Provider>);
    ReactDOM.render(component, div);
};
export function ShowNormalDeal({ sellerPriceYuanUnit, transferMode, orderId, callback }) {
    if (!componentRef) {
        createNormalDeal();
    }
    dispatch.normalDeal.ShowModal({ sellerPriceYuanUnit, transferMode, orderId, callback });
}
